import React, { createContext, useState } from 'react';
import PropTypes from 'prop-types';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    // Initializer functions
    const getToken = () => {
        const tokenStr = localStorage.getItem('token');
        if (!tokenStr) return null;
        try { const userToken = JSON.parse(tokenStr); return userToken?.vToken; } catch (e) { return null; }
    };
    const getName = () => {
        const tokenStr = localStorage.getItem('token');
        if (!tokenStr) return null;
        try { const userToken = JSON.parse(tokenStr); return userToken?.vNombre; } catch (e) { return null; }
    };
    const getNombreCompleto = () => {
        const tokenStr = localStorage.getItem('token');
        if (!tokenStr) return "";
        try {
            const userToken = JSON.parse(tokenStr);
            return userToken?.vNombre + " " + userToken?.vApellidos;
        } catch (e) { return ""; }
    };
    const getShowReleaseNotes = () => {
        const tokenStr = localStorage.getItem('token');
        if (!tokenStr) return false;
        try {
            const userToken = JSON.parse(tokenStr);
            if (userToken?.bShowReleaseNotes === true || userToken?.bShowReleaseNotes === "true") return true;
            return false;
        } catch (e) { return false; }
    };
    const getIdUsuario = () => {
        const tokenStr = localStorage.getItem('token');
        if (!tokenStr) return null;
        try { const userToken = JSON.parse(tokenStr); return userToken?.idUsuario; } catch (e) { return null; }
    };
    const getProfileImage = () => {
        const tokenStr = localStorage.getItem('token');
        if (!tokenStr) return null;
        try { const userToken = JSON.parse(tokenStr); return userToken?.imagen; } catch (e) { return null; }
    };
    const getUsuario = () => {
        const tokenStr = localStorage.getItem('token');
        if (!tokenStr) return null;
        try { const userToken = JSON.parse(tokenStr); return userToken?.vUsuario; } catch (e) { return null; }
    };
    const getIdCatTipoUsuario = () => {
        const tokenStr = localStorage.getItem('token');
        if (!tokenStr) return null;
        try { const userToken = JSON.parse(tokenStr); return userToken?.idCatTipoUsuario; } catch (e) { return null; }
    };
    const getEmail = () => {
        const tokenStr = localStorage.getItem('token');
        if (!tokenStr) return '';
        try { const userToken = JSON.parse(tokenStr); return userToken?.vEmailTrabajo || userToken?.vCorreo || ''; } catch (e) { return ''; }
    };

    // States
    const [token, setTokenState] = useState(getToken());
    const [usuario, setUsuario] = useState(getUsuario());
    const [idCatTipoUsuario, setIdCatTipoUsuario] = useState(getIdCatTipoUsuario());
    const [name, setName] = useState(getName());
    const [nombreCompleto, setNombreCompleto] = useState(getNombreCompleto());
    const [idUsuario, setIdUsuario] = useState(getIdUsuario());
    const [profileImage, setProfileImage] = useState(getProfileImage());
    const [email, setEmail] = useState(getEmail());
    const [showReleaseNotes, setShowReleaseNotes] = useState(getShowReleaseNotes());

    // Update localStorage wrappers
    const saveToken = userToken => {
        if (!userToken) {
            localStorage.removeItem('token');
            setTokenState(null);
            setEmail('');
            setUsuario(null);
            setIdCatTipoUsuario(null);
            setName(null);
            setNombreCompleto('');
            setIdUsuario(null);
            setProfileImage(null);
            setShowReleaseNotes(false);
            return;
        }
        localStorage.setItem('token', JSON.stringify(userToken));
        setTokenState(userToken?.vToken);
        setEmail(userToken?.vEmailTrabajo || userToken?.vCorreo || '');
        setUsuario(userToken?.vUsuario);
        setIdCatTipoUsuario(userToken?.idCatTipoUsuario);
        setName(userToken?.vNombre);
        setNombreCompleto(userToken?.vNombre + " " + userToken?.vApellidos);
        setIdUsuario(userToken?.idUsuario);
        setProfileImage(userToken?.imagen);
        if (userToken?.bShowReleaseNotes === true || userToken?.bShowReleaseNotes === "true") {
            setShowReleaseNotes(true);
        } else {
            setShowReleaseNotes(false);
        }
    };

    const saveImage = image => {
        const tokenStr = localStorage.getItem('token');
        if (tokenStr) {
            try {
                let userToken = JSON.parse(tokenStr);
                userToken.imagen = image;
                localStorage.setItem('token', JSON.stringify(userToken));
                setProfileImage(image);
            } catch (e) {
                // Ignore invalid token format or localStorage error
            }
        }
    };

    const saveShowReleaseNotes = (show) => {
        const tokenStr = localStorage.getItem('token');
        if (tokenStr) {
            try {
                let userToken = JSON.parse(tokenStr);
                userToken.bShowReleaseNotes = show;
                localStorage.setItem('token', JSON.stringify(userToken));
                setShowReleaseNotes(show);
            } catch (e) {
                // Ignore invalid token format or localStorage error
            }
        }
    };

    const contextValue = {
        setToken: saveToken,
        token,
        setName,
        name,
        nombreCompleto,
        setNombreCompleto,
        setIdUsuario,
        idUsuario,
        profileImage,
        setProfileImage: saveImage,
        setUsuario,
        usuario,
        idCatTipoUsuario,
        setIdCatTipoUsuario,
        email,
        setEmail,
        showReleaseNotes,
        setShowReleaseNotes: saveShowReleaseNotes
    };

    return (
        <AuthContext.Provider value={contextValue}>
            {children}
        </AuthContext.Provider>
    );
};

AuthProvider.propTypes = {
    children: PropTypes.node.isRequired
};

export default AuthProvider;
